import React, { useEffect, useState } from 'react';
import { CheckmarkFilled16, InProgress16 } from '@carbon/icons-react';
import UtilityIcon from 'components/UtilityIcons';

interface Props {
  assetOwner: any[];
  isLoading?: boolean;
}

export const AssetOwnerListDisabled: React.FC<Props> = ({
  assetOwner,
  isLoading
}) => {
  const [rows, setRows] = useState<any[]>([]);

  useEffect(() => {
    const entries = assetOwner
      ?.map((item: any) => {
        const { status, authority_name, organisation_type } = item;
        const icon = organisation_type || 'other';
        return {
          icon,
          assetOwnerName: authority_name,
          status: status
        };
      })
      .sort((itemA: any, itemB: any) =>
        itemA.assetOwnerName.localeCompare(itemB.assetOwnerName)
      );
    setRows(entries);
  }, [assetOwner]);

  return (
    <>
      {!isLoading && (
        <div className="accordion-disabled">
          {rows.map((row: any, idx: any) => {
            return (
              <div className="accordion-disabled-wrapper" key={idx}>
                <div className="accordion-title">
                  <div className="accordion-title-left-side">
                    <div className="icon-div">
                      <UtilityIcon type={row.icon} />
                    </div>
                    <div className="title-name">{row.assetOwnerName}</div>
                  </div>
                  <div className="status-div">
                    {row.status === 'received' ? (
                      <CheckmarkFilled16 className="status-received" />
                    ) : (
                      <InProgress16 className="status-others" />
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </>
  );
};

export default React.memo(AssetOwnerListDisabled);
